module.exports = __webpack_public_path__ + "static/media/white_bell.a6621197.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/white_bell.svg
// module id = 271
// module chunks = 0